import { formatDateShort } from '@/lib';
import { startOfMonth } from 'date-fns';
import { DATE_RANGE_TYPES, type DateRangeType } from '@/lib/constants/dateFormats';

export function formatDateRange(start: Date, end: Date): string {
    const startText = formatDateShort(start, true, true);
    const endText = formatDateShort(end, true, true);
    return `${startText} - ${endText}`;
}

export function getMTDText(): string {
    const now = new Date();
    const startOfCurrentMonth = startOfMonth(now);
    const endDate = new Date(now.getTime() + 24 * 60 * 60 * 1000);
    return formatDateRange(startOfCurrentMonth, endDate);
}

export function getCustomRangeText(rangeType: DateRangeType, startDate?: Date, endDate?: Date): string {
    if (rangeType === DATE_RANGE_TYPES.CUSTOM && startDate && endDate) {
        return formatDateRange(startDate, endDate);
    }
    return 'Custom Range';
}
